import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table, Modal } from 'react-bootstrap';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from 'yup';
import { ErrorMessage } from 'formik';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { FaCheckCircle, FaEdit, FaEye, FaPen } from 'react-icons/fa';
import * as bie from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa6";
import PreviewandPrint from '../PreviewandPrint';
export default function DeficienciesIdentifiedService() {

  const login = sessionStorage.getItem("user_id");
  const userName = sessionStorage.getItem("user_name")
  console.log("userName", userName);
  const statusScreenLogin = login && login.length > 5;
  const navigate = useNavigate();
  const [getDef, setDef] = useState([]);
  const [finalStatus, setFinalStatus] = useState(null);
  const collCode = sessionStorage.getItem("user_id");
  const [filetered, setFiletered] = useState([]);
  const [selectedNoc, setSelectedNoc] = useState(null);
  const [nocData, setNocData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const validationSchema = Yup.object({
    deficiencies: Yup.array().of(
      Yup.object({
        remarks: Yup.string()
          .required('Remarks is required')
          .min(5, 'Remarks must be at least 5 characters')
          .max(500, 'Remarks cannot exceed 500 characters'),
        // file: Yup.mixed().nullable(),
        file: Yup.mixed()
          .nullable()
          .test(
            "fileRequired",
            "File upload is required",
            function (value) {
              return value || getDef?.[0]?.file_upload;
            }
          ),
        // file: Yup.mixed().test(
        //   "fileRequired",
        //   "File upload is required",
        //   function (value) {
        //     const index = this.path.match(/\d+/)?.[0];

        //     return (
        //       value ||
        //       getDef?.[index]?.file_upload
        //     );
        //   }
        // ),

      })
    ),
  });

  const formik = useFormik({
    initialValues: {
      deficiencies: [],
      nocType: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("SUBMIT CLICKED", values);
      updateEOPDeficiencyDetails();
    },
  });
  const [errormsg, setErrormsg] = useState(null);
  const [defPdf, setDefPdf] = useState([])
  console.log("formik.errors", formik.errors)
  function getbyDeficiencytype(noc_type) {

    // ✅ STOP API CALL when noc_type empty
    if (!noc_type || noc_type.trim() === "") {

      // clear old data
      setDef([]);
      setFiletered([]);
      setFinalStatus(null);
      setErrormsg(null);

      formik.setFieldValue("deficiencies", []);

      return;
    }

    // ✅ clear previous stale data before API call
    setDef([]);
    setFiletered([]);
    setFinalStatus(null);

    let url = `${config.url.FAC_URL}getbyNocType?noc_type=${noc_type}&collCode=${collCode}`;

    CommonAxiosGet(url)
      .then((res) => {

        if (res && res.data.status === true) {

          const deficiencyDataRaw = res?.data?.data;

          const deficiencyData = Array.isArray(deficiencyDataRaw)
            ? deficiencyDataRaw
            : deficiencyDataRaw
              ? [deficiencyDataRaw]
              : [];

          const filteredata = deficiencyData.filter(
            (item) =>
              item?.cllg_remarks &&
              item?.cllg_remarks.trim() !== ""
          );

          setDef(deficiencyData);
          setFiletered(filteredata);

          const status = deficiencyData[0]?.final_status || null;

          setFinalStatus(status);

          if (deficiencyData.length > 0) {

            const mappedDeficiencies = deficiencyData.map((item) => ({
              sno: item.sno,
              remarks: item.cllg_remarks || "",
              file: null,

              ...(statusScreenLogin && {
                secondSrutinyRemarks:
                  item.second_scrutiny_remarks || "",
                secondSrutinyfile: null,
              }),
            }));

            formik.setFieldValue("deficiencies", mappedDeficiencies);
            setDefPdf(res?.data?.prcodeeingpdf?.[0]?.final_pdf_sign || "");

            setErrormsg(false);
          } else {
            setErrormsg(true);

            const emptyDef = statusScreenLogin
              ? [
                {
                  remarks: "",
                  file: null,
                  secondSrutinyRemarks: "",
                  secondSrutinyfile: null,
                },
              ]
              : [
                {
                  remarks: "",
                  file: null,
                },
              ];

            formik.setFieldValue(
              "deficiencies",
              emptyDef
            );
          }

        } else {

          // ✅ API failed
          setDef([]);
          setFiletered([]);
          setFinalStatus(null);
          setErrormsg(true);

        }
      })
      .catch((error) => {

        console.error(
          "Error fetching deficiencies:",
          error
        );

        setDef([]);
        setFiletered([]);
        setFinalStatus(null);
        setErrormsg(true);
      });
  }
  function updateEOPDeficiencyDetails() {
    const deficienciesPayload = formik.values.deficiencies.map((def) => ({
      sno: def.sno,
      cllgRemarks: def.remarks,
      fileUpload: def.file,
      nocType: formik.values.nocType,
      // Include second scrutiny data only for logged‑in users
      ...(statusScreenLogin && {
        secondSrutinyRemarks: def.secondSrutinyRemarks,
        secondSrutinyfile: def.secondSrutinyfile,
      }),
    }));

    const url = config.url.FAC_URL + `updateEOPDeficiencyDetails`;
    CommonAxiosPost(url, deficienciesPayload)
      .then((res) => {
        if (res && res.data.status === true) {
          successAlert2(res.data.sdesc);
          getbyDeficiencytype(); // refresh after submit
        } else {
          failureAlert(res?.data?.sdesc || "Update failed");
        }
      })
      .catch((error) => {
        console.error("Error updating deficiency details:", error);
        const errorMsg = error?.response?.data?.sdesc || error?.response?.data?.message || "Something went wrong";
        failureAlert(errorMsg);
      });
  }
  useEffect(() => {
    getData();
  }, []);
  function getData() {
    let url = `${config.url.FAC_URL}getcollegestatus?collCode=${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          setNocData(res.data.data);
        } else {
          setNocData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching NOC data:", error);
        setNocData([]);
      });
  }
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  return (
    <>

      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> College Preview {collCode}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <PreviewandPrint
            nocType={previewData.nocType}
            collCode={previewData.collCode}
          />
        </Modal.Body>
      </Modal>
      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          <header className="top-header top-headerfoot">
            <div className="par-logopart">
              <img src="../images/MAINLOGO.png" alt="" className="img-fluid" />

              <div className="paralogo-text">
                <h4 className="mb-0">
                  Higher Education Department </h4>
                <p className="mb-0"> Government of Andhra Pradesh</p>
              </div>
            </div>
          </header>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <bie.Row className="pt-2 mb-4 align-items-center">
                <div className="d-flex justify-content-between align-items-center mb-3">

                  <h5 className="text-success mb-0">
                    Application Status Report For {userName}-({login}) <pre />
                    {/* {nocData.length > 0 && (<span className="text-danger mb-0">
                      Note: Please provide remarks and upload supporting documents for all
                      college-level deficiencies listed below.
                    </span>
                    )} */}
                  </h5>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </button>
                </div>
              </bie.Row>
              {nocData?.length > 0 ? (
                <>

                  <Table bordered responsive>
                    <thead className="table-primary text-center">
                      <tr>
                        <th>S.No</th>
                        <th>NOC Type</th>
                        <th>Proceedings  /Deficiency PDF</th>
                        <th>College Preview</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {nocData?.map((item, index) => {
                        const isDeficiencyIdentified =
                          item.jd_status === "Deficiencies Identified";

                        let isSubmitted = false;

                        if (item.noc_type === "eop") {
                          isSubmitted = item.eop_done === "Done";
                        } else if (item.noc_type === "management") {
                          isSubmitted = item.manage_done === "Done";
                        } else if (item.noc_type === "shifting") {
                          isSubmitted = item.shifting_done === "Done";
                        }
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>{(item.noc_type || "").toUpperCase()}</td>
                            {/* <td>{(item.noc_type || "")}</td> */}


                            <td className="text-center">
                              <Button
                                variant="primary"


                                onClick={() => { viewImage(item.final_pdf_sign); }}
                              >
                                <FaEye />
                              </Button>
                            </td>
                            {/* <td className="text-center">
                              <Button
                                variant="primary"
                                onClick={() =>
                                  navigate("/CollegeDetailss", {
                                    state: {
                                      nocType: item.noc_type,
                                      collCode: item?.coll_code
                                    },
                                  })
                                }
                              >
                                <FaEye />
                              </Button>
                            </td> */}
                            <td className="text-center">
                              <Button
                                variant="primary"
                                onClick={() => {
                                  setPreviewData({
                                    nocType: item.noc_type,
                                    collCode: item.coll_code,
                                  });
                                  setShowPreview(true);
                                }}
                              >
                                <FaEye />
                              </Button>
                            </td>

                            <td className="text-center">

                              <td className="text-center">
                                {item.jd_status === "Conditionally Approved" ? (
                                  <span className="text-success fw-bold">
                                    Conditional Approved
                                  </span>
                                ) : item.jd_status === "Approved" ? (
                                  <span className="text-success fw-bold">
                                    Approved
                                  </span>
                                ) : isDeficiencyIdentified && isSubmitted ? (
                                  <Button
                                    style={{
                                      textDecoration: "underline",
                                      color: "blue",
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSelectedNoc(item);
                                      formik.setFieldValue("nocType", item.noc_type);
                                      getbyDeficiencytype(item.noc_type);
                                      setShowModal(true);
                                    }}
                                  >
                                    <FaEye size={25} className="me-2 text-primary text-center" />
                                    Click here to view & submit the Deficiency Details
                                  </Button>
                                ) : isDeficiencyIdentified ? (
                                  <Button
                                    style={{
                                      textDecoration: "underline",
                                      color: "blue",
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSelectedNoc(item);
                                      formik.setFieldValue("nocType", item.noc_type);
                                      getbyDeficiencytype(item.noc_type);
                                      setShowModal(true);
                                    }}
                                  >
                                    <FaEdit size={25} className="me-2 text-primary" />
                                    Click Here to Fill the Deficiency Details
                                  </Button>
                                ) : (
                                  <span className="text-muted">
                                    {item.jd_status || "-"}
                                  </span>
                                )}
                              </td>
                            </td>
                          </tr>
                        )
                      })}

                    </tbody>
                  </Table>
                  <bie.Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    size="xl"
                    centered
                  >
                    <bie.Modal.Header closeButton>
                      <bie.Modal.Title className="text-success text-center">
                        {selectedNoc?.noc_type?.replaceAll("_", " ").toUpperCase() || ""} - Deficiencies Details
                      </bie.Modal.Title>
                    </bie.Modal.Header>

                    <bie.Modal.Body>
                      <Row>
                        <Col>
                          <Table bordered responsive>
                            <thead className="table-primary text-center">
                              <tr>
                                <th style={{ width: "5%" }}>S.No</th>
                                <th style={{ width: "35%" }}>Particulars</th>
                                <th style={{ width: "35%" }}>Remarks</th>
                                <th style={{ width: "25%" }}>Upload</th>
                                {statusScreenLogin && (
                                  <>
                                    <th style={{ width: "35%" }}>Second Remarks</th>
                                    <th style={{ width: "25%" }}>Second Supporting Doc</th>
                                  </>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {getDef.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.deficiency_description || item.remarks || item.deficiency || item.deficiences || "-"}</td>

                                  {/* First Remarks */}
                                  <td>
                                    <textarea
                                      name={`deficiencies[${index}].remarks`}
                                      value={formik.values.deficiencies[index]?.remarks || ""}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      rows="2"
                                      placeholder="Enter remarks for this deficiency..."
                                      style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px',
                                        resize: 'vertical'
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`deficiencies[${index}].remarks`}
                                      component="div"
                                      style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}
                                    />
                                  </td>

                                  {/* First File Upload */}
                                  <td>
                                    <input
                                      type="file"
                                      className="form-control"
                                      accept="application/pdf"
                                      onChange={(e) => {
                                        ImagePdfBucket(e, formik, "/Uploads/grievupload/", `deficiencies[${index}].file`, "file", "pdf");
                                      }}
                                      onBlur={formik.handleBlur}
                                      style={{ border: '1px solid #ccc' }}
                                    />
                                    {item.file_upload && (
                                      <Button
                                        type="button"
                                        className="btn btn-primary ms-2"
                                        style={{ marginLeft: "18px", cursor: "pointer" }}
                                        onClick={() => viewImage(item.file_upload)}
                                      >
                                        <FaEye size={10} />
                                      </Button>
                                    )}
                                    <ErrorMessage
                                      name={`deficiencies[${index}].file`}
                                      component="div"
                                      style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}
                                    />
                                  </td>

                                  {/* Second Scrutiny Fields (only for logged‑in users) */}
                                  {statusScreenLogin && (
                                    <>
                                      <td>
                                        <textarea
                                          name={`deficiencies[${index}].secondSrutinyRemarks`}
                                          value={formik.values.deficiencies[index]?.secondSrutinyRemarks || ""}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          rows="2"
                                          placeholder="Enter second remarks for this deficiency..."
                                          style={{
                                            width: '100%',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            border: '1px solid #ccc',
                                            fontSize: '14px',
                                            resize: 'vertical'
                                          }}
                                        />
                                        <ErrorMessage
                                          name={`deficiencies[${index}].secondSrutinyRemarks`}
                                          component="div"
                                          style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="file"
                                          className="form-control"
                                          accept="application/pdf"
                                          onChange={(e) => {
                                            ImagePdfBucket(e, formik, "/Uploads/grievupload/", `deficiencies[${index}].secondSrutinyfile`, "file", "pdf");
                                          }}
                                          onBlur={formik.handleBlur}
                                          style={{ border: '1px solid #ccc' }}
                                        />
                                        {item.second_scrutiny_file && (
                                          <Button
                                            type="button"
                                            className="btn btn-primary ms-2"
                                            style={{ marginLeft: "18px", cursor: "pointer" }}
                                            onClick={() => viewImage(item.second_scrutiny_file)}
                                          >
                                            <FaEye size={10} />
                                          </Button>
                                        )}
                                        <ErrorMessage
                                          name={`deficiencies[${index}].secondSrutinyfile`}
                                          component="div"
                                          style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}
                                        />
                                      </td>
                                    </>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          {/* Submit / Already Submitted */}
                          {filetered.length > 0 ? (
                            <div className="text-end mt-3">
                              <span className="text-success">Already Submitted</span>
                            </div>
                          ) : (
                            <div className="text-end mt-3">
                              {/* <button type="submit" className="btn btn-primary">
                            Submit
                          </button> */}
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => formik.handleSubmit()}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </bie.Modal.Body>
                  </bie.Modal>
                </>) : <><h5 className="text-danger text-center mb-3">No Data Found</h5></>}
              {/* {finalStatus === "DeficiencyIdentified" && Array.isArray(getDef) && getDef.length > 0 ? (
                <>
                  <p
                    style={{ color: "brown", textAlign: "center", fontWeight: "bold" }}
                    type="button"
                    onClick={() => viewImage(defPdf)}

                  >
                    Click here to Download Deficiency  <FaRegFilePdf size={40} />

                  </p>
                </>
              ) : finalStatus === "NoDeficienciesIdentified" ? (
                <Card className="text-center shadow-sm m-4">
                  <Card.Body>
                    <FaCheckCircle size={50} className="text-success mb-3" />
                    <Card.Title className="text-success">No Deficiencies Identified</Card.Title>
                    <Card.Text>Your application has no deficiencies.</Card.Text>
                    <p
                      style={{ color: "brown", textAlign: "center", fontWeight: "bold" }}
                      type="button"
                      onClick={() => viewImage(defPdf)}

                    >
                      Click here to Download Proceedings  <FaRegFilePdf size={40} />

                    </p>
                  </Card.Body>
                </Card>
              ) :
                <></>
              } */}




            </Form>
          </FormikProvider>


          <footer className='forgot-footer' >
            <p className='mb-0'>Designed and Developed by <a href='https:apcfss.in/' target='_blank'>
              <img src='../images/footer-logo.svg' alt='' className='img-fluid' />
            </a>
            </p>
          </footer>
        </div>
      </div >
    </>

  );
}